import React from 'react';
import { BarChart2Icon } from 'lucide-react';
export const ServiceRequestWidget = () => {
  const requestStats = [{
    status: 'New',
    count: 28,
    color: 'bg-blue-500'
  }, {
    status: 'In Progress',
    count: 42,
    color: 'bg-yellow-500'
  }, {
    status: 'Pending Info',
    count: 17,
    color: 'bg-orange-500'
  }, {
    status: 'Completed',
    count: 63,
    color: 'bg-green-500'
  }];
  const totalRequests = requestStats.reduce((sum, stat) => sum + stat.count, 0);
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 h-full" data-id="element-2043">
      <div className="px-6 py-4 border-b border-gray-200" data-id="element-2044">
        <h2 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-2045">
          <BarChart2Icon className="h-5 w-5 text-blue-500 mr-2" data-id="element-2046" />
          Service Request Overview
        </h2>
      </div>
      <div className="p-6" data-id="element-2047">
        <div className="flex items-center justify-between mb-4" data-id="element-2048">
          <div data-id="element-2049">
            <p className="text-3xl font-bold text-gray-900" data-id="element-2050">{totalRequests}</p>
            <p className="text-sm text-gray-500" data-id="element-2051">Total Active Requests</p>
          </div>
          <div className="text-right" data-id="element-2052">
            <p className="text-sm font-medium text-green-600" data-id="element-2053">+12%</p>
            <p className="text-xs text-gray-500" data-id="element-2054">from last week</p>
          </div>
        </div>
        <div className="space-y-4" data-id="element-2055">
          {requestStats.map((stat, index) => <div key={index} data-id="element-2056">
              <div className="flex justify-between items-center mb-1" data-id="element-2057">
                <span className="text-sm text-gray-600" data-id="element-2058">{stat.status}</span>
                <span className="text-sm font-medium text-gray-900" data-id="element-2059">
                  {stat.count}
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-2060">
                <div className={`${stat.color} h-2 rounded-full`} style={{
              width: `${stat.count / totalRequests * 100}%`
            }} data-id="element-2061"></div>
              </div>
            </div>)}
        </div>
      </div>
      <div className="px-6 py-3 bg-gray-50 border-t border-gray-200" data-id="element-2062">
        <a href="#" className="text-sm font-medium text-blue-600 hover:text-blue-800" data-id="element-2063">
          View detailed report
        </a>
      </div>
    </div>;
};